import React, { Component } from "react";
import { Row, Col } from "antd";


export const Sidebar = props => {
  return (
    <aside>
    </aside>
  );
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Sidebar/SidebarComponent.js